import AddingCollaborators from "../../../../src/courses/partials/team-management/adding-collaborators.mdx";
import * as React from 'react';
export default {
  AddingCollaborators,
  React
};